import { BrowserModule } from '@angular/platform-browser';
import { APP_ID, ErrorHandler, NgModule, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { QuicklinkModule } from 'ngx-quicklink';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NEVER } from 'rxjs';
import { ToastrModule, ToastContainerDirective } from 'ngx-toastr';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { SelectModule } from 'primeng/select';
import Aura from '@primeuix/themes/aura';

import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { HandleUnrecoverableStateService  } from './services/handle-unrecoverable-state.service';
import { CheckForUpdateService } from './services/check-for-update.service';
import { LogUpdateService } from './services/log-update.service';
import { PromptUpdateService } from './services/prompt-update.service';
import { ServiceWorkerRegistrationService, SW_SCRIPT } from './services/service-worker-registration.service';
import { DatadogErrorHandler } from '../datadog_config';
import { NewVersionCheckerComponent } from './new-version-checker/new-version-checker.component';
import { ViewOnlyBannerComponent } from './core/layout/view-only-banner/view-only-banner.component';

/**
 * This is the first module loaded. It bootstraps
 * the rest of the application.
 */
@NgModule({
	declarations: [	 
		AppComponent
		, NewVersionCheckerComponent
   	]
	, imports: [
		BrowserModule
		, CoreModule
        , SelectModule
		, QuicklinkModule
		, BrowserAnimationsModule
		, ToastrModule.forRoot({
            maxOpened: 2
            , autoDismiss: true 
            , newestOnTop: true
        }) 
		, ToastContainerDirective
		// S2N-3226: ServiceWorkerRegistrationService is the one place the worker is registered. A
		// strategy that never emits keeps SwUpdate enabled but stops Angular registering it again.
		, ServiceWorkerModule.register(
			SW_SCRIPT
			, {
				enabled: true
				, registrationStrategy: () => NEVER
			}
		)
		, ModalModule
        , MatProgressSpinnerModule
        // S2N-3076: the read-only banner the shell renders above the routed page for a View Only user
        , ViewOnlyBannerComponent
	]
	, providers: [
		CheckForUpdateService
		, LogUpdateService
		, PromptUpdateService
		, HandleUnrecoverableStateService
		, { 
			provide: ErrorHandler
			, useClass: DatadogErrorHandler
		}
        , provideAppInitializer(() => inject(ServiceWorkerRegistrationService).register())
		, { 
            provide: APP_ID,  
            useValue: 'ng-cli-universal' 
        }
        , provideAnimationsAsync()
        , providePrimeNG(
            {
                theme: {
                    preset: Aura
                    , options: { darkModeSelector: '.dark-theme' }
                }
            }
        )
        , provideZoneChangeDetection()
	]
	, bootstrap: [ AppComponent ]
})
export class AppModule { }
